import { formatTo12Hour } from '@/utils/time'
import {
  groupProviderHours,
  providerShiftTime,
} from './cobaltProviderSchedules'
import type { CobaltProviderDay } from './types'

export function CobaltProviderHours({ hours }: { hours: CobaltProviderDay[] }) {
  return (
    <div className="space-y-1 text-xs leading-relaxed">
      {groupProviderHours(hours).map(({ days, shifts }) => (
        <div key={days}>
          <span className="font-medium">{days}</span>
          {' · '}
          {!shifts.length
            ? 'Closed'
            : shifts.map((shift, index) => (
                <span key={JSON.stringify(shift)}>
                  {index > 0 && ', '}
                  <span className="whitespace-nowrap">
                    {shift.closed ? (
                      'Closed'
                    ) : (
                      <>
                        {formatTo12Hour(providerShiftTime(shift.start))}–
                        {formatTo12Hour(providerShiftTime(shift.end))}
                      </>
                    )}
                  </span>
                  {shift.facility_name && ` · ${shift.facility_name}`}
                  {(shift.set_start_date || shift.set_end_date) && (
                    <span className="block text-muted-foreground">
                      {shift.set_start_date ?? 'No start date'} →{' '}
                      {shift.set_end_date ?? 'No end date'}
                    </span>
                  )}
                  {typeof shift.recurrence?.recur_interval_description ===
                    'string' && (
                    <span className="block text-muted-foreground">
                      {shift.recurrence.recur_interval_description}
                    </span>
                  )}
                </span>
              ))}
        </div>
      ))}
    </div>
  )
}
